import { Helmet } from "react-helmet-async"
import {
	ITransportServiceProvider,
	TSPTripWiseBookings,
} from "../../../../../TransportServiceProviders"
import { useOutletContext } from "react-router"

export default function TransportServiceProviderBookingsPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ITransportServiceProvider
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Trip Wise Bookings | TSP</title>
			</Helmet>
			<TSPTripWiseBookings
				transportServiceProvider={transportServiceProvider}
			/>
		</>
	)
}
